import {h, Component, Fragment} from "preact";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as I from "../utils/icons";

import MenuFull from "../desktop-components/menu-full.jsx";
import {MenuSportsOnly} from "../desktop-components/menu-sports-only.jsx";
import MenuTopleagues from "../desktop-components/menu-topleagues.jsx";
import MenuSearchEvent from "../desktop-components/menu-search-event.jsx";
import MenuBetServices from "../desktop-components/menu-bet-services.jsx";
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import PrematchCarousel from "../desktop-components/prematch-carousel.jsx";

import PrematchLastMinute from "../desktop-components/prematch-last-minute.jsx";
import PrematchLiveEvents from "../desktop-components/prematch-live-events.jsx";
import PrematchTournamentSelector from "../desktop-components/prematch-tournament-selector.jsx";
import PrematchTournament from "../desktop-components/prematch-tournament.jsx";
import PrematchEvent from "../desktop-components/prematch-event.jsx";
import PrematchQuickbet from "../desktop-components/prematch-quickbet.jsx";
import PrematchHomeWidgets from "../desktop-components/prematch-home.jsx";

import PrematchEventsWidget from "../desktop-components/prematch-events-widget.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";
import { MarketingEvents } from "../../../utils/gtm-module";
import { EmbeddedMinigame } from "../desktop-components/casino/embedded-minigame";


export default function Prematch() {
	return <FullSite><PrematchTemplate /></FullSite>;
}

function PrematchTemplate() {
	return <div class="font-roboto">
		{false && <L.TopRowContainer>
		  <L.ContainerLink>
			<L.TopPageLink href="/prematch" active={true}>Sport Home</L.TopPageLink>
			<L.TopPageLink href="/live">Live</L.TopPageLink>
		  </L.ContainerLink>
		</L.TopRowContainer>}
		<div class="flex border-b border-b-zinc-950 bg-blue-whale-900 text-white p-3 gap-3">
		  <div class="w-72 flex-none">
			{/* <M.MenuRow>
			  <M.MenuTitleLabel>Sports Menu</M.MenuTitleLabel>
			  <M.MenuCollapseBtnHolder><I.AnglesLeft class="h-4" /></M.MenuCollapseBtnHolder>
			</M.MenuRow>/>*/}
			<MenuTopleagues callback={item => Page.openTournaments([item.id])} />
			{false && <a class="flex h-8 items-center border-b border-b-zinc-950 bg-zinc-800 hover:bg-zinc-700 text-white" href="/live">
			  <M.MenuTitleCenteredLabel><I.StopwatchRegular class="h-3 mr-1" /><span>IN-PLAY</span></M.MenuTitleCenteredLabel>
			</a>}
			<div class="rounded-xl overflow-hidden mb-3 bg-slate-100 text-slate-950"><MenuTimeFilter />
			<MenuSearchEvent /></div>
			<MenuFull />
			<M.BlankSeparator />
			  {/*<EsportsMenu /><M.BlankSeparator />*/}
			<MenuBetServices />
		  </div>
		  <div class="min-w-0 grow">
			{/*<PrematchTournamentSelector />*/}
			{/*<PrematchTournament />*/}
			{/*<PrematchEvent />*/}
			<PageContent />
		  </div>
		  <div class="w-72 flex-none">
			<PrematchQuickbet />
			<M.BlankSeparator />
			<T.ColumnTicketWrappper>
				<T.TicketTopRow>
					<TicketHeader />
				</T.TicketTopRow>
				<TicketBody />
				<EndedTicketPopups />
			</T.ColumnTicketWrappper>
			<M.BlankSeparator />
			<TicketLoadBet />
			<M.BlankSeparator />
			<TicketCheckBet />
			<M.BlankSeparator />
			<EmbeddedMinigame />
		  </div>
		</div>
	</div>
}

export class PageContent extends Component {
	render() {
		const openTournaments = Page.mapTournaments(tournamentInfo => tournamentInfo);
		if (openTournaments.length == 0) {
			return <HomeContents />
		} else {
			return <TournamentsList openTournaments={openTournaments} />
		}
	}
}

export class HomeContents extends Component {
	componentWillMount() {
		window.dispatchEvent(new Event(MarketingEvents.HOMEPAGE))
	}
	render() {
		return <div>
			<PrematchCarousel />
			<PrematchEventsWidget />
			<PrematchHomeWidgets />
			{false && <PrematchLiveEvents />}
			{false && <PrematchLastMinute />}
		</div>
	}
}

export class TournamentsList extends Component {
	render({openTournaments}) {
		return openTournaments.reverse().map(tournamentInfo => (
			<PrematchTournament key={tournamentInfo.tournament.id} tournamentCard={tournamentInfo.card} tournament={tournamentInfo.tournament} />
		))
	}
}


